import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useRouteMatch } from 'react-router-dom';
import Button from '../../../../shared/components/buttons/Button';
import { Type } from '../../../../models/UserServerData';
import { NS } from '../../../../models/I18n';
import { Country } from '../../../../models/Country';
import { Question } from '../../../../shared/components/forms/Question';
import { ButtonGroup, OptionButton } from '../../../../shared/components/buttons/OptionButton';

export interface TypeSelectionProps {
  visible: boolean;
  type: Type | '';
  setType: (type: Type | '') => void;
  setIsCompleted: React.Dispatch<React.SetStateAction<boolean>>;
  country: Country | null;
  setCountry: React.Dispatch<React.SetStateAction<Country | null>>;
}

function TypeSelection({ visible, type, setType, setIsCompleted, country, setCountry }: TypeSelectionProps) {
  const { t } = useTranslation(NS.Eligibility);
  // if match is not null, it means that the user is at the partner's lead gen
  const match = useRouteMatch<{ submissionId: string }>('/eligibility/:submissionId');
  const typeSelectionQuestions: Map<Country, string> = new Map([
    ['CA', t('typeSelection.question-canada')],
    ['US', t('typeSelection.question-us')],
  ]);

  useEffect(() => {
    if (visible) {
      setIsCompleted(country !== null && type !== '');
    }
  }, [visible, type, country, setIsCompleted]);

  return (
    <div className={visible ? '' : 'hidden'}>
      {!match && (
        <>
          <Question>{t('typeSelection.select-country')}</Question>
          <ButtonGroup>
            <OptionButton selected={country === 'CA'} onClick={() => setCountry('CA')}>
              {t('typeSelection.canada')}
            </OptionButton>
            <OptionButton selected={country === 'US'} onClick={() => setCountry('US')}>
              {t('typeSelection.us')}
            </OptionButton>
          </ButtonGroup>
        </>
      )}
      {country && (
        <>
          <Question>{typeSelectionQuestions.get(country)}</Question>
          <ButtonGroup>
            {match && (
              <OptionButton selected={type === 'immigrate'} onClick={() => setType('immigrate')}>
                {t('typeSelection.immigrate')}
              </OptionButton>
            )}
            <OptionButton selected={type === 'work'} onClick={() => setType('work')}>
              {t('typeSelection.work')}
            </OptionButton>
            <OptionButton selected={type === 'study'} onClick={() => setType('study')}>
              {t('typeSelection.study')}
            </OptionButton>
            <OptionButton selected={type === 'visitor'} onClick={() => setType('visitor')}>
              {t('typeSelection.visit')}
            </OptionButton>
          </ButtonGroup>
        </>
      )}
    </div>
  );
}

export default TypeSelection;
